import { useNavigate } from "react-router-dom";
import { Button } from "../components/Button";

const Unauthorized = () => {
  const navigate = useNavigate();

  const goBack = () => navigate(-1);

  return (
    <section>
      <div className="fixed inset-0 z-10 flex items-center justify-center">
        <div className="bg-white rounded-lg shadow-xl w-[75vh]">
          <div className="p-6">
            <div className="flex items-center">
              <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center rounded-full bg-red-100">
                <svg
                  className="h-6 w-6 text-red-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
                  />
                </svg>
              </div>
              <div className="ml-4">
                <h3 className="text-xl font-semibold text-red-900">
                  Unauthorized
                </h3>
                <p className="mt-2 text-sm text-gray-500">
                  You do not have access to the requested page.
                </p>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 px-4 py-3 flex justify-end">
            <Button handleClick={goBack} value="Go Back" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Unauthorized;

